import {defineStore} from 'pinia'
import {config} from "@/core/config";
import {SmartSearchConfig} from "@/main";
import {searchErrorLogger} from "@/core/Logger";


export const usePopularQueriesStore = defineStore('PopularQueriesStore', {
  state: () => {
    return {
      queries: [],
    }
  },
  getters: {
    hasPopularQueries(state) {
      return state.queries.length > 0
    },
    getPopularQueries(state) {
      // eslint-disable-next-line @typescript-eslint/ban-ts-comment
      // @ts-ignore
      return state.queries.slice(0, SmartSearchConfig.value.onfocus.popularQueries.count)
    }
  },
  actions: {
    async fetchPopularQueries() {
      // eslint-disable-next-line @typescript-eslint/ban-ts-comment
      // @ts-ignore
      const popularQueriesEnabled = SmartSearchConfig.value.onfocus.popularQueries.enabled
      if (!popularQueriesEnabled) {
        return []
      }
      try {
        const response = await fetch(
          `https://${config.apiHost}/restapi/${config.customerSymbol}/search/${config.searchId}/queries/popular`,
          {
            method: 'GET',
            credentials: 'include',
            headers: {
              'Api-key': config.apiKey,
            },
          }
        )
        
        if (response.ok) {
          const data = await response.json()
          const {queries} = data
          
          this.queries = queries
        }
      } catch (error) {
        searchErrorLogger.log('Error retrieving search results:', error)
      }
    }
    
    
  },
})